<template>
  <div class="purchse-cart">
    <div v-if="!updateEmail">
      <div class="cart-list-nav">
        <div class="total-credits">
          {{ $t('mobileScan.purchase_total') }} $
          {{ getTotalAmount() }}
        </div>
        <div class="total-items">
          {{ getSelectedItemLength() }}
          {{ $t('mobileScan.purchase_item') }}
        </div>
      </div>
      <shop-item
        v-for="(store, idx) in stores"
        :key="idx"
        :id="`${idx + 1}`"
        :name="store.name"
        :data="store.itemData"
        :selected="store.selectedDefault"
        :quantity="data.details ? data.details[idx].credits : 1"
        @change="onInputShopItemChange"
      />
      <div class="reminder-text">{{ $t('mobileScan.purchase_reminder') }}</div>
      <div class="buttons-wrap">
        <c-button
          :confirmedStatus="getSelectedItemLength() !== 0"
          :buffering="buffering"
          @click="$emit('pay')"
        >
          <span>{{ $t('mobileScan.purchase_checkout') }}</span>
        </c-button>
      </div>
    </div>
    <UpdateEmail v-else @close="$emit('close-update-email')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CButton from '@/components/common/CButton.vue';
import page from '@/mixins/page';
import UpdateEmail from '@/components/MobileScan/Purchase/UpdateEmail.vue';

import ShopItem from '@/components/MobileScan/Purchase/Cart/ShopItem.vue';

export default {
  name: 'MyCart',
  mixins: [page],
  components: {
    CButton,
    ShopItem,
    UpdateEmail,
  },
  props: {
    updateEmail: Boolean,
    data: {
      type: Object,
      defalt() {
        return {};
      },
    },
  },
  data() {
    return {
      checked: [],
      selectedItems: [],
      buffering: false,
    };
  },
  computed: {
    ...mapGetters('app', [
      'canUseMobileScan',
      'storeName',
      'mobileScanPrice',
      'mobileScannerConfigs',
    ]),
    stores() {
      return this.getUserLinkedStore();
    },
  },
  methods: {
    getSelectedItemLength() {
      let items = 0;
      items = this.selectedItems.length;
      return items;
    },
    getTotalCredits() {
      let credits = 0;
      if (this.selectedItems.length) {
        this.selectedItems.forEach(item => {
          credits += +item.credits;
        });
      }
      return credits;
    },
    getTotalAmount() {
      let credits = 0;
      if (this.selectedItems.length) {
        this.selectedItems.forEach(item => {
          credits += +item.credits;
        });
      }
      return (credits * this.mobileScanPrice).toFixed(1);
    },
    onInputShopItemChange(data) {
      const existedData = this.selectedItems.find(item => item.id === data.id && item);

      if (existedData !== undefined) {
        const idx = this.selectedItems.findIndex(item => item.id === data.id);
        this.selectedItems[idx] = data;
      } else {
        if (!data.selected) return;
        this.selectedItems.push(data);
      }
      this.selectedItems = this.selectedItems.filter(item => item.selected === true);
      this.getTotalCredits();
      this.getSelectedItemLength();

      let purchasingData = null;

      if (this.selectedItems.length) {
        purchasingData = {
          totalCredits: this.getTotalCredits(),
          details: this.selectedItems,
        };
      }

      this.$emit('update', purchasingData);
    },
    getUserLinkedStore() {
      return [
        {
          name: this.storeName,
          checked: true,
          selectedDefault: true,
          itemData: {
            itemPrice: this.mobileScanPrice,
            itemName: this.$t('mobileScan.credits'),
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.purchse-cart {
  @apply h-full flex flex-col w-full;

  > div {
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}

.cart-item {
  background-color: #999;
  border-radius: 8px;
}

.cart-list-nav {
  @apply w-full flex flex-row justify-between mb-4;
}

.reminder-text {
  @apply mt-auto text-xs font-normal text-center;
}

.buttons-wrap {
  @apply w-full flex flex-row justify-around pb-6 mt-4;
}
</style>
